import type { Role } from "../api/roles";
import { canManageEmployees } from "./rolePermissions";

/** Roles a user with `loginRoleKey` may assign in the Add Employee form.
 *
 * Only management-tier roles (per `canManageEmployees`) may assign anyone at
 * all — supervisor and employee are view-only/self-service tiers and assign
 * nothing, matching the original `ROLE_OPTIONS_BY_LOGIN_ROLE` (where
 * `supervisor: []`). Among those who can manage, a user may assign every role
 * ranked strictly below their own. A login role not present in the list (e.g.
 * "admin"/"owner") is treated as top authority (rank 0) and may assign all. */
export function assignableRoles(roles: Role[], loginRoleKey: string | null | undefined): Role[] {
  const key = (loginRoleKey || "").toLowerCase();
  if (!canManageEmployees(key)) return [];
  const mine = roles.find((r) => r.role_key === key);
  const myRank = mine ? mine.rank : 0;
  return roles
    .filter((r) => r.rank > myRank)
    .sort((a, b) => a.rank - b.rank);
}
